import { render, staticRenderFns } from "./ViewEventParticipants.vue?vue&type=template&id=3994ec87&scoped=true&"
import script from "./ViewEventParticipants.vue?vue&type=script&lang=ts&"
export * from "./ViewEventParticipants.vue?vue&type=script&lang=ts&"
import style0 from "./ViewEventParticipants.vue?vue&type=style&index=0&id=3994ec87&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3994ec87",
  null
  
)

export default component.exports